module.exports = __webpack_public_path__ + "static/media/homepage_atf_2_en.e9b9ec0f.png";